import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronRightIcon } from '@heroicons/react/outline'

const Breadcrumb = (props) => {

    const chevronRightIcon = <ChevronRightIcon className="w-5 h-5 text-slate-500"/>
  return (
    <div className="flex items-center gap-3">
        <Link to="/" className="text-xl text-slate-500 hover:text-blue-500">Dasbor</Link>
        {chevronRightIcon}
        {
            props.middle ? (
                <Link to={props.middle.route} className="text-xl text-slate-500 hover:text-blue-500">{props.middle.label}</Link>
            ) : ("")
        }
        {
            props.middle ? (
                chevronRightIcon
            ) : ("")
        }
        <span className="text-xl text-slate-500">{props.current}</span>
    </div>
  )
}

export default Breadcrumb